import { CustomQuery, DashboardComponent, Definition, Root, Subsurvey, ThirdPartyCheck } from "@aidkitorg/types/lib/survey";
import { DistroComponent } from "@aidkitorg/types/lib/translation/questions";
import { expandTemplatesStrict } from "@aidkitorg/types/lib/translation/v0_to_legacy";

export type SearchableComponent =
  DistroComponent
  | CustomQuery['visualization']
  | DashboardComponent
  | ThirdPartyCheck['type']
  | Definition;

export default function enumerateSubsurveys(root: Root): Subsurvey[] {
  let expanded = expandTemplatesStrict(root)
  if (!expanded) return [];

  function traverse(block: SearchableComponent): Subsurvey[] {
    if (block.kind == 'Subsurvey') {
      return [block, ...block.sections.flatMap(traverse)];
    }
    if (block.kind == 'Section') {
      return block.components.flatMap(traverse);
    }
    if (block.kind == 'Collection') {
      return block.components.flatMap(traverse);
    }
    return [];
  }
  const subsurveys = (Array.isArray(expanded) ? expanded : expanded.survey).flatMap(traverse);
  return subsurveys;
}
